import { Logger } from '../logger';
const console = new Logger('FilesystemPlugins');
/**
 * Singleton registry for filesystem plugins
 */
class FilesystemPluginRegistry {
    constructor() {
        this.plugins = new Map();
        this.defaultPluginId = null;
    }
    register(plugin) {
        const id = plugin.getId();
        if (this.plugins.has(id)) {
            console.warn(`[PluginRegistry] Plugin '${id}' already registered, replacing`);
        }
        this.plugins.set(id, plugin);
        console.log(`[PluginRegistry] Registered plugin: ${id} (${plugin.getName()})`);
        if (this.defaultPluginId === null) {
            this.defaultPluginId = id;
        }
    }
    get(id) {
        return this.plugins.get(id) || null;
    }
    getAll() {
        return Array.from(this.plugins.values());
    }
    getIds() {
        return Array.from(this.plugins.keys());
    }
    has(id) {
        return this.plugins.has(id);
    }
    setDefault(id) {
        if (!this.plugins.has(id)) {
            throw new Error(`Cannot set default plugin '${id}': not registered`);
        }
        this.defaultPluginId = id;
    }
    getDefault() {
        if (this.defaultPluginId === null) {
            return null;
        }
        return this.plugins.get(this.defaultPluginId) || null;
    }
    getDefaultId() {
        return this.defaultPluginId;
    }
}
export const pluginRegistry = new FilesystemPluginRegistry();
